import { loader } from '@monaco-editor/react'
import * as monaco from 'monaco-editor'
import './monacoWorkers'
import './assets/fonts/jetbrains-mono/font.css'
import { codeEditorTheme, codeEditorThemeName } from './components/common/codeEditorTheme'

// Use locally installed monaco-editor instead of CDN (avoids network/CSP failures)
monaco.editor.defineTheme(codeEditorThemeName, codeEditorTheme)
loader.config({ monaco })

// Monaco caches glyph measurements. Re-measure after the bundled font arrives,
// without replacing models, undo stacks, cursor positions or user selections.
void document.fonts?.load('14px "JetBrains Mono"')
  .then(() => monaco.editor.remeasureFonts())
  .catch(() => { /* A font-load failure keeps the local monospace fallback usable. */ })
